
<span
    class="modal-trigger"
    @click.prevent="openModal"
><slot /></span>
